import React from 'react';
import PropTypes from 'prop-types';
import Table from "react-bootstrap/Table";
import BatchPagination from '../../batch/BatchPagination';

const SellerRateCardListing = (props) => {
    const {
        sortingColumn,
        handleSortingCoulmn,
        sortOrder,
        permissions,
        renderList,
        AllSellerRateCards,
        activeTab,
        sellernumberOfPage,
        numOfPage,
        sellerCurrentPage,
        sellerTotalPages,
        AllSellerRateCardsRecord,
        setsellerCurrentPage,
        setsellernumberOfPage
    } = props;
    return (
        <>

            <div className="main_content_table_history incomingTbl tableFixHead">
                <Table className="table  table-height">
                    <thead>
                        <tr>
                            <th>
                                <button
                                    className={
                                        sortingColumn === "SellerRateCardName"
                                            ? "active sortBtn"
                                            : "sortColumn sortBtn"
                                    }
                                    onClick={(e) => handleSortingCoulmn(e, "SellerRateCardName")}
                                >
                                    Name{" "}
                                    <i
                                        className={
                                            sortingColumn === "SellerRateCardName" &&
                                                sortOrder === "ASCENDING"
                                                ? "fa fa-arrow-up"
                                                : "fa fa-arrow-down"
                                        }
                                        aria-hidden="true"
                                    ></i>
                                </button>
                            </th>
                            <th>
                                <button
                                    className={
                                        sortingColumn === "IsActive"
                                            ? "active IsActive sortBtn"
                                            : "sortColumn IsActive sortBtn"
                                    }
                                    onClick={(e) => handleSortingCoulmn(e, "IsActive")}
                                >
                                    Status {" "}
                                    <i
                                        className={
                                            sortingColumn === "IsActive" &&
                                                sortOrder === "ASCENDING"
                                                ? "fa fa-arrow-up"
                                                : "fa fa-arrow-down"
                                        }
                                        aria-hidden="true"
                                    ></i>
                                </button>
                            </th>
                            <th>
                                <button
                                    className={
                                        sortingColumn === "CarrierProviderName"
                                            ? "active CarrierProviderName sortBtn"
                                            : "sortColumn CarrierProviderName sortBtn"
                                    }
                                    onClick={(e) => handleSortingCoulmn(e, "CarrierProviderName")}
                                >
                                    Carrier Provider {" "}
                                    <i
                                        className={
                                            sortingColumn === "CarrierProviderName" &&
                                                sortOrder === "ASCENDING"
                                                ? "fa fa-arrow-up"
                                                : "fa fa-arrow-down"
                                        }
                                        aria-hidden="true"
                                    ></i>
                                </button>
                            </th>



                            {permissions?.baseRateCard && (
                                <th>Effective Sellers / Companies</th>
                            )}
                            <th>Effective From</th>
                            <th>Effective Till</th>
                            <th className="sticky">Actions</th>
                        </tr>
                    </thead>
                    {renderList()}
                </Table>
            </div>
            {AllSellerRateCards && activeTab === 2 && (
                <BatchPagination
                    gridData={AllSellerRateCards}
                    totalVisualRecords={AllSellerRateCards?.length}
                    numberOfPage={sellernumberOfPage}
                    numOfPage={numOfPage}
                    currentPage={sellerCurrentPage}
                    totalPages={sellerTotalPages}
                    totalRecords={
                        AllSellerRateCardsRecord?.Entity?.TotalRecords
                    }
                    setCurrentPage={setsellerCurrentPage}
                    setNumberOfPage={setsellernumberOfPage}
                />
            )}
        </>
    );
}

SellerRateCardListing.propTypes = {
    sortingColumn: PropTypes.string,
    handleSortingCoulmn: PropTypes.func,
    sortOrder: PropTypes.string,
    permissions: PropTypes.object,
    renderList: PropTypes.func,
    AllSellerRateCards: PropTypes.array,
    activeTab: PropTypes.number,
    sellernumberOfPage: PropTypes.number,
    numOfPage: PropTypes.number,
    sellerCurrentPage: PropTypes.number,
    sellerTotalPages: PropTypes.number,
    AllSellerRateCardsRecord: PropTypes.object,
    setsellerCurrentPage: PropTypes.func,
    setsellernumberOfPage: PropTypes.func
};

export default SellerRateCardListing;